export default __webpack_public_path__ + "static/media/medicalIntelligence.fdc5be7a.png";